var g = (t, r, e) => {
  if (!r.has(t))
    throw TypeError("Cannot " + e);
};
var p = (t, r, e) => (g(t, r, "read from private field"), e ? e.call(t) : r.get(t)), h = (t, r, e) => {
  if (r.has(t))
    throw TypeError("Cannot add the same private member more than once");
  r instanceof WeakSet ? r.add(t) : r.set(t, e);
}, f = (t, r, e, o) => (g(t, r, "write to private field"), o ? o.call(t, e) : r.set(t, e), e);
import { P as v } from "./pwc-element-CZs0VuUW.js";
import { i as y } from "./utils-CiFqmvKy.js";
import { r as b } from "./state-D4BCZ2JK.js";
import { n } from "./property-4FoNj0Pi.js";
var m = Object.defineProperty, s = (t, r, e, o) => {
  for (var a = void 0, l = t.length - 1, d; l >= 0; l--)
    (d = t[l]) && (a = d(r, e, a) || a);
  return a && m(r, e, a), a;
}, u, c;
class i extends v {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(...e) {
    super(...e);
    h(this, u, void 0);
    h(this, c, void 0);
    this.id = "", this.autofocus = !1, this.focused = !1, f(this, u, (o) => {
      this.focused = !0, super.emit("p-focus", this.event(o));
    }), f(this, c, (o) => {
      this.focused = !1, super.emit("p-blur", this.event(o));
    });
  }
  static get properties() {
    return {
      _form: {
        type: String,
        attribute: "form"
      },
      tabindex: {
        converter: y(
          "the 'tabindex' attribute is not supported by this element, use 'tab-index' instead'"
        )
      },
      tabIndex: {
        attribute: "tab-index",
        type: Number,
        reflect: !0
      }
    };
  }
  get _hintMessage() {
    return this.focused && this.hintMessage || void 0;
  }
  get status() {
    var e, o, a;
    return (e = this.errorMessages) != null && e.length || this.error ? "error" : (o = this.warningMessages) != null && o.length || this.warning ? "warning" : (a = this.successMessages) != null && a.length || this.success ? "success" : void 0;
  }
  get form() {
    var e;
    return (e = this.interactiveEl) == null ? void 0 : e.form;
  }
  interactiveElementRef(e) {
    var o, a;
    (o = this.interactiveEl) == null || o.removeEventListener("focus", p(this, u)), (a = this.interactiveEl) == null || a.removeEventListener("blur", p(this, c)), e == null || e.addEventListener("focus", p(this, u)), e == null || e.addEventListener("blur", p(this, c)), this.interactiveEl = e;
  }
  event(e) {
    return {
      detail: {
        target: this.interactiveEl,
        originalEvent: e
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
  }
  click() {
    var e;
    (e = this.interactiveEl) == null || e.click();
  }
  focus() {
    var e;
    (e = this.interactiveEl) == null || e.focus();
  }
  blur() {
    var e;
    (e = this.interactiveEl) == null || e.blur();
  }
}
u = new WeakMap(), c = new WeakMap();
s([
  n({ type: String, reflect: !0 })
], i.prototype, "id");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "readonly");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "disabled");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "required");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "autofocus");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "error");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "warning");
s([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "success");
s([
  n({ attribute: "error-messages" })
], i.prototype, "errorMessages");
s([
  n({ attribute: "success-messages" })
], i.prototype, "successMessages");
s([
  n({ attribute: "warning-messages" })
], i.prototype, "warningMessages");
s([
  n({ type: String, attribute: "hint-message" })
], i.prototype, "hintMessage");
s([
  n({ type: Boolean, attribute: "hide-details" })
], i.prototype, "hideDetails");
s([
  b()
], i.prototype, "focused");
export {
  i as P
};
